/**
 * Zeus find-dealer CTA — scroll stinger choreography (GSAP ScrollTrigger, scrubbed).
 * Three acts on one section: content settles on entry, the lightning bolt
 * crosses the band during traversal, content lifts away on exit.
 * Static fallback without GSAP / with prefers-reduced-motion: no init at all.
 */
(function () {
  function waitForGsap(callback) {
    if (typeof window.zeusWhenGsapReady === "function") {
      window.zeusWhenGsapReady(callback);
      return;
    }
    if (window.gsap && window.ScrollTrigger) callback();
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initSection(root) {
    if (root.dataset.zeusFdctaInit === "true") return;
    root.dataset.zeusFdctaInit = "true";

    var gsap = window.gsap;
    var inner = root.querySelector(".zeus-fdcta__inner");
    var media = root.querySelector(".zeus-fdcta__media");
    var btnSeat = root.querySelector(".zeus-fdcta__btn-seat");
    var bolt = root.querySelector(".zeus-fdcta__bolt");

    if (!inner) {
      return;
    }

    /* Act 1 — entry: copy slides in, button snaps into its seat (overshoot). */
    var entry = gsap.timeline({
      scrollTrigger: {
        trigger: root,
        start: "top 94%",
        end: "top 58%",
        scrub: 0.5,
        invalidateOnRefresh: true,
      },
    });

    if (media) {
      entry.fromTo(media, { opacity: 0, x: -28 }, { opacity: 1, x: 0, ease: "none" }, 0);
    }
    if (btnSeat) {
      entry.fromTo(
        btnSeat,
        { opacity: 0, y: 26, scale: 0.92 },
        { opacity: 1, y: 0, scale: 1, ease: "back.out(1.6)" },
        0.2,
      );
    }

    /* Act 2 — traversal: the band breathes (counter-parallax) while the
       signature bolt crosses from offscreen-left to its resting spot. */
    gsap.fromTo(
      inner,
      { yPercent: 5 },
      {
        yPercent: -5,
        ease: "none",
        scrollTrigger: {
          trigger: root,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );

    if (bolt) {
      gsap.set(bolt, { x: 0, rotation: 0 });
      gsap.fromTo(
        bolt,
        {
          x: function () {
            return -root.offsetWidth * 0.92;
          },
          rotation: -12,
          opacity: 0.2,
        },
        {
          x: 0,
          rotation: 0,
          opacity: 0.55,
          ease: "none",
          scrollTrigger: {
            trigger: root,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true,
          },
        },
      );
    }

    /* Act 3 — exit: content lifts away as the band leaves the viewport. */
    gsap.fromTo(
      inner,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -22,
        ease: "none",
        immediateRender: false,
        scrollTrigger: {
          trigger: root,
          start: "bottom 36%",
          end: "bottom 6%",
          scrub: 0.5,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  function boot() {
    var roots = document.querySelectorAll("[data-zeus-fdcta]");
    if (!roots.length || prefersReducedMotion()) {
      return;
    }

    roots.forEach(function (root) {
      var initialize = function () {
        waitForGsap(function () {
          window.gsap.registerPlugin(window.ScrollTrigger);
          initSection(root);
        });
      };

      if (typeof window.zeusWhenNearViewport === "function") {
        window.zeusWhenNearViewport(root, initialize);
      } else {
        initialize();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
